'use strict';

export default {
    community: state => state.community,
    terms: state => state.terms,
    hideMembers: state => state.community.hide_members
};
